export function isMobileDevice() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }
  
  /**
   * 检测当前设备是否为桌面设备
   * @returns {boolean} true表示是桌面设备，false表示不是
   */
  export function isDesktopDevice() {
    return !isMobileDevice();
  }